import { ExercisesTable } from '../../components/Tables/ExercisesTable';
import { SearchInput } from '../../components/UI/SearchInput';
import { PageContainer } from '../../components/Layout/PageContainer';
import { PageBreadcrumb } from '../../components/UI/PageBreadcrumb';
import { useExercisesQuery } from '../../query/useExercisesQuery';
import { Spinner } from '@chakra-ui/react';

export function ExercisesPage() {
  const { data, isLoading } = useExercisesQuery()

  return (
    <PageContainer>
      <PageBreadcrumb items={['Home', 'Exercises']} />
      <SearchInput />
      {isLoading ? <Spinner size="xl" mt="40px" color="teal.500" /> :
        <ExercisesTable data={data ?? []} onAdd={() => {}} />
      }
    </PageContainer>
  );
}